import { T, C } from '@homeschooling/sdk'

import * as React from 'react'
//import * as _ from 'lodash'

import Persistance from "../Persistence";

import { EditSchedule, Expand, AddExpense, AddNote, Location, Notes, Expenses, DeleteSchedule } from '../../Components/Icons'
import HorizontalLine from '../Common/HorizonalLine';
import Clock from '../Icons/Clock';
import Modal from '../Modal';
import AddNoteForm from '../Form/AddNoteForm'
import AddExpenseForm from '../Form/AddExpenseForm'
import EditScheduleForm from '../Form/EditScheduleForm';
import Expanded from './Expanded'
import DeleteScheduleForm from '../Form/DeleteScheduleForm'

import defaultAva from '../../Components/brand/default_ava.svg'
import { Helper } from '../../Components/Helpers'

export interface Props {
    children?: React.ReactNode
    event: T.Schedule
    currentDay: string
    updateNote: (note: T.Progress) => void
    updateExpense: (expense: T.Expense) => void
    updateSchedule: () => void
}

export interface State {
    event: T.Schedule
    expandExpenses: boolean
    expandNotes: boolean
    showAddNotes: boolean
    showAddExpense: boolean
    showExpanded: boolean
    showEditSchedule: boolean
    showDeleteSchedule: boolean
}

Persistance.setValues()

export class Focus extends React.Component<Props, any> {

    public constructor(props: Props) {
        super(props)

        this.state = {
            event: this.props.event,
            expandExpenses: false,
            expandNotes: false,
            showAddNotes: false,
            showAddExpense: false,
            showExpanded: false,
            showDeleteSchedule: false
        }
    }

    public setEvent = (event: T.Schedule) => {
        this.setState({ event: event })
    }

    public buildNotes = (notes: T.Progress[]) => {

        if (notes.length === 0) {
            return (<div></div>)
        }

        let display: any[] = []

        if (this.state.expandNotes) {

            for (let n of notes) {
                display.push(<div id={`notes_${n.id}`} className='w-full flex justify-stretch text-sm border-b-white'>
                    <div className='w-12 grow p-2 text-left text-wrap'>{n.description}</div>
                </div>)
            }
        }

        return (
            <div className='w-full flex flex-col bg-slate-100 p-2 rounded-lg py-4'>
                <div className='w-full flex flex-row items-center cursor-pointer'
                    onClick={() => this.setState({ expandNotes: !this.state.expandNotes })}>
                    <div className='flex flex-none'>
                        <Notes
                            className='fill-slate-500 pr-2 flex'
                            size='large' />
                    </div>
                    <div className='flex-grow text-md'>
                        Notes
                    </div>
                </div>

                <div className='flex grow flex-col pl-2'>
                    {display}
                </div>
            </div>
        )
    }

    public buildExpenses = (expenses: T.Expense[]) => {

        if (expenses.length === 0) {
            return (<div></div>)
        }

        let display: any[] = []

        if (this.state.expandExpenses) {

            display.push(<div id={`expense_header`} className="flex items-center flex-row text-sm justify-left h-auto py-3 font-semibold bg-slate-100">
                <div className='w-12 grow text-left flex-none text-s px-2'>
                    Description
                </div>
                <div className='w-24 h-auto text-sm align-middle text-lext px-2 flex-none'>
                    Price
                </div>
                <div className='w-28 text-right text-sm align-middle flex-none'>
                    Date
                </div>
            </div>
            )

            for (let e of expenses) {
                display.push(<div id={`expenses_${e.id}`} className='w-full flex justify-stretch text-sm border-b-white'>
                    <div className='w-12 grow px-2 text-left text-ellipsis'>{e.description}</div>
                    <div className='w-24 flex-none px-2 text-left'>${e.price}</div>
                    <div className='w-28 text-right flex-none'>{e.date}</div>
                </div>)
            }
        }

        return (
            <div className='w-full flex flex-col bg-slate-100 p-2 rounded-lg py-4'>
                <div className='w-full flex flex-row items-center cursor-pointer'
                    onClick={() => this.setState({ expandExpenses: !this.state.expandExpenses })}>
                    <div className='flex flex-none'>
                        <Expenses
                            className='fill-slate-500 pr-2 flex'
                            size='large' />
                    </div>
                    <div className='flex-grow text-md'>
                        Expenses
                    </div>
                </div>

                <div className='flex grow flex-col pl-2'>
                    {display}
                </div>
            </div>
        )
    }


    public toggleEdit = async () => {
        this.setState( {showEditSchedule: !this.state.showEditSchedule})
    }

    public toggleDelete = async () => {
        this.setState( {showDeleteSchedule: !this.state.showDeleteSchedule})
    }

    public toggleAddNote = async () => {

        this.setState({ showAddNote: !this.state.showAddNote })
    }

    public toggleAddExpense = async () => {

        this.setState({ showAddExpense: !this.state.showAddExpense })
    }

    public toggleExpanded = async () => {
        this.setState({ showExpanded: !this.state.showExpanded})
    }

    public updateNote = (note: T.Progress) => {

        //let event = this.state.event
        //event.notes.push(note)
        this.props.updateNote(note)
        this.setState({ showAddNotes: false })

    }

    public updateExpense = (expense: T.Expense) => {

        //let event = this.state.event
        //event.expenses.push(expense)
        this.props.updateExpense(expense)
        this.setState({ showAddExpense: false })

        //this.setState({ event })

    }

    public getAddNoteForm = () => {

        return (<AddNoteForm
            event={this.state.event}
            date={this.props.currentDay}
            closeForm={() => this.toggleAddNote()}
            inPlaceUpdate={(note) => this.updateNote(note)}
            form={{}}
            errors={{}}
        />
        )
    }

    public getEditScheduleForm = () => {

        return (<EditScheduleForm
            schedule={this.state.event}
            closeForm={() => this.toggleEdit()}
            inPlaceUpdate={() => this.props.updateSchedule()}
            date={this.props.currentDay}
        />
        )
    }

    public getDeleteScheduleForm = () => {

        return (<DeleteScheduleForm
            scheduele={this.state.event}
            closeForm={() => this.toggleDelete()}
            inPlaceUpdate={() => this.props.updateSchedule()}
            date={this.props.currentDay}
        />
        )
    }

    public getAddExpenseForm = () => {

        return (<AddExpenseForm
            event={this.state.event}
            date={this.props.currentDay}
            closeForm={() => this.toggleAddExpense()}
            inPlaceUpdate={(expense) => this.updateExpense(expense)}
            form={{}}
            errors={{}}
        />
        )
    }

    public showExpandedEvent = () => {

        return (<Expanded
            event={this.state.event}
            currentDay={this.props.currentDay}
            updateNote={(note: T.Progress) => this.props.updateNote(note)}
            updateExpense={(expense: T.Expense) => this.props.updateExpense(expense)}
            close={() => this.toggleExpanded()}
        />
        )
    }

    public render(): React.ReactNode {

        const { currentDay } = this.props
        const { event } = this.state
        const student = event.students[0]
        
        let ava = false ? 'img' : defaultAva

        let subjectConstants = C.getSubjectConstants(event.subject)
        //let course = subjectConstants[event.course]

        if (this.props.event.id !== event.id) {
            this.setEvent(this.props.event)
        }

        let iconClass = 'cursor-pointer fill-slate-500 hover:fill-black mx-1'

        let location = () => {
            if (event.location && event.location !== '') {
                return (
                    <div className='w-full text-right flex flex-row px-2 items-center'>
                        <div className='flex'>
                            <Location
                                className='fill-slate-500 pr-2 flex'
                                size='medium'
                            />
                        </div>
                        <div className='flex'>
                            {event.location}
                        </div>
                    </div>

                )
            } else {
                return (<div></div>)
            }
        }

        return (<div className='focused_event w-full h-full flex flex-col'>
            <Modal
                open={this.state.showAddNote}
                onClose={this.toggleAddNote}
                aria-labelledby="parent-modal-title"
                aria-describedby="parent-modal-description"
            >
                {this.getAddNoteForm()}
            </Modal>
            <Modal
                open={this.state.showEditSchedule}
                onClose={this.toggleEdit}
                aria-labelledby="parent-modal-title"
                aria-describedby="parent-modal-description"
            >
                {this.getEditScheduleForm()}
            </Modal>
            <Modal
                open={this.state.showDeleteSchedule}
                onClose={this.toggleDelete}
                aria-labelledby="parent-modal-title"
                aria-describedby="parent-modal-description"
            >
                {this.getDeleteScheduleForm()}
            </Modal>
            <Modal
                open={this.state.showAddExpense}
                onClose={this.toggleAddExpense}
                aria-labelledby="parent-modal-title"
                aria-describedby="parent-modal-description"
            >
                {this.getAddExpenseForm()}
            </Modal>
            <Modal
                open={this.state.showExpanded}
                onClose={this.toggleExpanded}
                size='w-1/2'
                aria-labelledby="parent-modal-title"
                aria-describedby="parent-modal-description"
            >
                {this.showExpandedEvent()}
            </Modal>
            <div className='w-full flex grow flex-col'>
                <div className='w-full flex flex-col grow'>

                    <div className='w-full h-auto flex flex-row flex-none justify-end p-2'>
                        <div className='flex' onClick={() => this.toggleExpanded()}>
                            <Expand
                                className={iconClass}
                                size='medium' />
                        </div>
                        <div className='flex' onClick={() => this.toggleAddNote()}>
                            <AddNote
                                className={iconClass}
                                size='medium' />
                        </div>
                        <div className='flex' onClick={() => this.toggleAddExpense()}>
                            <AddExpense
                                className={iconClass}
                                size='medium' />
                        </div>
                        <div className='flex' onClick={() => this.toggleEdit()}>
                            <EditSchedule
                                className={iconClass}
                                size='medium' />
                        </div>
                        <div className='flex' onClick={() => this.toggleDelete()}>
                            <DeleteSchedule
                                className={iconClass}
                                size='medium' />
                        </div>


                    </div>

                    <div className='w-full items-center justify-start flex flex-none p-2 flex-row'>
                        <div className='w-full bg-slate-200 p-2 rounded-lg flex flex-row items-center'>
                            <div className='flex flex-none flex-none'>
                                <img className="object-cover bg-slate-600 w-6 h-6 rounded-full" src={ava} alt={student.name} />
                            </div>
                            <div className='flex text-right pl-2 text-small font-medium text-slate-700'>
                                {student.name}
                            </div>
                        </div>

                    </div>

                    <div className='w-full flex flex-col p-2'>

                        <div className='w-full text-sm font-semibold flex flex-col md:flex-row text-right justify-start items-center text-slate-800 py-1'>
                            <Clock
                                className='hidden fill-slate-500 pr-2 md:flex'
                                size='medium' />
                            {`${Helper.formatTime(`${currentDay} ${event.starts_at}`, event.tz, 'ddd, MMM DD YYYY   |  h:mm a')} -> ${Helper.formatTime(`${currentDay} ${event.ends_at}`, event.tz, 'h:mm a')}`}
                        </div>

                        <div className='w-full capitalize text-left text-slate-900 pt-2 text-2xl/10 font-medium'>
                            {event.name}
                        </div>
                        <div className='w-full text-left text-sm text-base pb-1 text-slate-800'>
                            {event.description}
                        </div>
                        <div className='w-full flex py-4'>
                            <div className='flex flex-col sm:flex-row w-full md:w-auto text-sm flex-none text-left'>
                                <div className='flex pe-2 text-right flex-grow self-end'>{`${C.subject[event.subject].label}`}</div>  
                                <div className='hidden sm:flex'>  |  </div>
                                <div className='flex px-2 flex-none self-end'>{`${subjectConstants[event.course].label}`}</div>
                            </div>
                        </div>
                        {location()}
                        <div className='py-8'>
                            <HorizontalLine
                                color='#999999'
                                size='1px'
                                padding='3.5em' />
                        </div>

                        <div className='pb-2'>
                            {this.buildNotes(event.notes)}
                        </div>
                        <div>
                            {this.buildExpenses(event.expenses)}
                        </div>
                    </div>
                </div>
            </div>
        </div>)
    }

}

export default Focus